import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import * as GoogleMapsClient from '@google/maps';
import GeocoderResult = google.maps.GeocoderResult;
import {google} from "google-maps";
import {DistanceType} from "../types/distance.type";
import {DistancePipe} from "../pipes/distance.pipe";


@Injectable()
export class GoogleMapsService {

  private googleMapsClient;

  constructor( @Inject('GoogleMapsApiKey') private GoogleMapsApiKey:string ){
    this.googleMapsClient = GoogleMapsClient.createClient({
      key: this.GoogleMapsApiKey,
      Promise: Promise
    });
  }

  public geocoding(address = ''){
    return this.googleMapsClient.geocode({
      address: String(address)
    }).asPromise()
      .then(response =>  response.json.results)
      .catch(err => console.log(err))
  }

  public reverseGeocoding(latlng = ''){
    return this.googleMapsClient.geocode({
      address: String(latlng)
    }).asPromise()
      .then(response =>  response.json.results)
      .catch(err => console.log(err))

  }

  public computeDistance(latLngA: any, latLngB: any, fractionDigits: number = 2): DistanceType {
    if (!latLngA || !latLngB) return;

    latLngA = new google.maps.LatLng(latLngA.lat, latLngA.lng);
    latLngB = new google.maps.LatLng(latLngB.lat, latLngB.lng);

    let distance = google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB);

    return new DistancePipe().transform(distance, fractionDigits);
  }

}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/services/googleMaps.service.ts